"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = buildSearchQuery;

var _date = require("@ha/date");

var _RoomKind = require("./constants/RoomKind");

var _buildParams = _interopRequireDefault(require("./buildParams"));

var _isDefined = _interopRequireDefault(require("./utils/isDefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var getEnumsByValues = function getEnumsByValues(values, types, typesEnum) {
  return Object.entries(types).filter(function (pair) {
    return values.includes(pair[1]);
  }).map(function (_a) {
    var type = _a[0];
    return typesEnum[type];
  }).join(',');
};

function buildSearchQuery(filters) {
  if (filters === void 0) {
    filters = {};
  }

  var _a = filters.listingKinds,
      listingKinds = _a === void 0 ? [] : _a,
      _b = filters.listingCategories,
      listingCategories = _b === void 0 ? [] : _b,
      startDate = filters.startDate,
      endDate = filters.endDate;
  var complexFilterKeys = ['listingKinds', 'listingCategories', 'startDate', 'endDate'];
  var query = Object.keys(filters).filter(function (key) {
    return !complexFilterKeys.includes(key);
  }).filter(function (key) {
    return (0, _isDefined["default"])(filters[key]);
  }).reduce(function (acc, key) {
    var _a;

    return __assign(__assign({}, acc), (_a = {}, _a[key] = filters[key], _a));
  }, {});

  if (startDate) {
    query.startDate = (0, _date.normalizeDate)(startDate);
  }

  if (endDate) {
    query.endDate = (0, _date.normalizeDate)(endDate);
  }

  if (listingKinds.length > 0) {
    query.kinds = getEnumsByValues(listingKinds, _RoomKind.Kinds, _RoomKind.KindsEnum);
  }

  var categories = listingCategories.reduce(function (acc, category) {
    return acc + "&categories=" + category;
  }, '');
  var params = (0, _buildParams["default"])(query);
  return categories ? "" + params + categories : params;
}